module.exports = __webpack_public_path__ + "img/cp3_02.c6e2a528.jpg";